import { calcZontMapStats_ } from 'entities/device.map.track/lib/statisic';
import { binarySearchByField } from 'utils';
import { convertPoints, filterGpsJumps, markTeleports, zontTrackingIcon, } from 'entities/device.map.track/lib';
export async function calcZontMapStats(gps, device, time) {
    const { l } = binarySearchByField(gps, 'time', new Date(time.mintime * 1e3));
    const { r } = binarySearchByField(gps, 'time', new Date(time.maxtime * 1e3));
    return calcZontMapStats_(device.fuel_consumption, gps, l, r);
}
export async function calcZontTrackAndIcons(raw_data) {
    return Promise.resolve({
        gps: markTeleports(filterGpsJumps(convertPoints(raw_data.gps)), raw_data.events),
        icons: (raw_data.events || [])
            .map(zontTrackingIcon)
            .filter((icon) => icon != null),
    });
}
export async function zontCalcGraph(requests, requestSender) {
    let result = {};
    await requestSender
        .post({
        type: 'load_data_for_zont_graphs',
        requests,
    })
        .then((el) => {
        result = el;
    })
        .catch((error) => {
        console.log('load_data_for_zont_graphs', error);
    });
    return result;
}
